module.exports = __webpack_public_path__ + "static/media/sell_finish_service_rent_3.090d74e0.jpg";